import { LuPhone } from "react-icons/lu";
import { business, process } from "../../content/site";

/**
 * Process
 *
 * A named, numbered four-step service path. Steps come from site.js.
 * The connector between steps is a plain CSS rule — horizontal across the
 * row on md and up, vertical down the left edge on phones. No arrow glyphs,
 * no icon fonts, no emoji.
 */
const Process = () => (
  <section id="process" className="section bg-surface-sunken">
    <div className="container-page">
      <p className="kicker">How a service call works</p>
      <h2 className="mt-3 max-w-prose text-heading-lg text-ink">
        Four steps, and you know the price before step four.
      </h2>
      <p className="mt-4 max-w-prose text-body-lg text-ink-muted">
        No guessing about what happens after you call. This is the same sequence
        on a dead outlet and on a full panel replacement.
      </p>

      <ol className="mt-10 grid gap-0 md:grid-cols-4 md:gap-6">
        {process.map((item, index) => {
          const isLast = index === process.length - 1;

          return (
            <li key={item.step} className="flex min-w-0 gap-4 md:block">
              {/* Number badge plus connector rule */}
              <div className="flex shrink-0 flex-col items-center self-stretch md:flex-row md:items-center md:gap-4 md:self-auto">
                <span
                  className="flex h-10 w-10 shrink-0 items-center justify-center
                             rounded-pill bg-surface-brand text-body-sm font-bold
                             text-ink-inverse tabular"
                  aria-hidden="true"
                >
                  {item.step}
                </span>
                <span
                  aria-hidden="true"
                  className={
                    isLast
                      ? "hidden"
                      : "w-px flex-1 bg-line md:h-px md:w-auto md:flex-1"
                  }
                />
              </div>

              {/* Copy */}
              <div className="min-w-0 pb-8 md:pb-0 md:pt-5">
                <h3 className="text-heading text-ink [overflow-wrap:anywhere]">
                  <span className="sr-only">{`Step ${item.step}: `}</span>
                  {item.title}
                </h3>
                <p className="mt-2 max-w-prose text-body text-ink-muted">
                  {item.body}
                </p>
              </div>
            </li>
          );
        })}
      </ol>

      <div className="mt-4 flex flex-col items-start gap-3 border-t border-line pt-8 sm:flex-row sm:items-center sm:gap-6">
        <a
          href={business.phone.href}
          className="btn-urgent w-full sm:w-auto"
          aria-label={`Call ${business.shortName} at ${business.phone.display}`}
        >
          <LuPhone aria-hidden="true" className="h-5 w-5 shrink-0" />
          <span className="tabular">{business.phone.display}</span>
        </a>
        <p className="max-w-prose text-body-sm text-ink-muted">
          Tell us what the power is doing and we will start at step one.
        </p>
      </div>
    </div>
  </section>
);

export default Process;
